var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React from 'react';
import styled from 'styled-components';
import { ComponentThemeProvider } from '../ThemeProvider';
import cardTheme from './theme';
export var ElevationLevel;
(function (ElevationLevel) {
    ElevationLevel["0dp"] = "0";
    ElevationLevel["1dp"] = "0 1px 3px 0 rgba(0, 0, 0, 0.2), 0 2px 1px -1px rgba(0, 0, 0, 0.12), 0 1px 1px 0 rgba(0, 0, 0, 0.14)";
    ElevationLevel["2dp"] = "0 1px 5px 0 rgba(0, 0, 0, 0.2), 0 3px 1px -2px rgba(0, 0, 0, 0.12), 0 2px 2px 0 rgba(0, 0, 0, 0.14)";
    ElevationLevel["3dp"] = "0 1px 8px 0 rgba(0, 0, 0, 0.2), 0 3px 3px -2px rgba(0, 0, 0, 0.12), 0 3px 4px 0 rgba(0, 0, 0, 0.14)";
    ElevationLevel["4dp"] = "0 2px 4px -1px rgba(0, 0, 0, 0.2), 0 1px 10px 0 rgba(0, 0, 0, 0.12), 0 4px 5px 0 rgba(0, 0, 0, 0.14)";
    ElevationLevel["6dp"] = "0 3px 5px -1px rgba(0, 0, 0, 0.2), 0 1px 18px 0 rgba(0, 0, 0, 0.12), 0 6px 10px 0 rgba(0, 0, 0, 0.14)";
    ElevationLevel["8dp"] = "0 5px 5px -3px rgba(0, 0, 0, 0.2), 0 3px 14px 2px rgba(0, 0, 0, 0.12), 0 8px 10px 1px rgba(0, 0, 0, 0.14)";
    ElevationLevel["9dp"] = "0 5px 6px -3px rgba(0, 0, 0, 0.2), 0 3px 16px 2px rgba(0, 0, 0, 0.12), 0 9px 12px 1px rgba(0, 0, 0, 0.14)";
    ElevationLevel["12dp"] = "0 7px 8px -4px rgba(0, 0, 0, 0.2), 0 5px 22px 4px rgba(0, 0, 0, 0.12), 0 12px 17px 2px rgba(0, 0, 0, 0.14)";
    ElevationLevel["16dp"] = "0 8px 10px -5px rgba(0, 0, 0, 0.2), 0 6px 30px 5px rgba(0, 0, 0, 0.12), 0 16px 24px 2px rgba(0, 0, 0, 0.14)";
    ElevationLevel["24dp"] = "0 11px 15px -7px rgba(0, 0, 0, 0.2), 0 9px 46px 8px rgba(0, 0, 0, 0.12), 0 24px 38px 3px rgba(0, 0, 0, 0.14)";
})(ElevationLevel || (ElevationLevel = {}));
var CardWrapper = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: block;\n  overflow: ", ";\n  box-sizing: border-box;\n  border-radius: 3px;\n  box-shadow: ", ";\n  background-color: ", ";\n"], ["\n  display: block;\n  overflow: ", ";\n  box-sizing: border-box;\n  border-radius: 3px;\n  box-shadow: ", ";\n  background-color: ", ";\n"])), function (_a) {
    var showOverflow = _a.showOverflow;
    return (showOverflow ? 'visible' : 'hidden');
}, function (_a) {
    var elevationLevel = _a.elevationLevel;
    return elevationLevel;
}, function (_a) {
    var theme = _a.theme;
    return theme.component.cardwrapper.bgColor;
});
var CardActiveWrapper = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: block;\n  height: 100%;\n  overflow: ", ";\n  border-radius: 3px;\n  margin-left: ", ";\n  box-shadow: ", ";\n  transition: all 0.3s ease-out;\n"], ["\n  display: block;\n  height: 100%;\n  overflow: ", ";\n  border-radius: 3px;\n  margin-left: ",
    ";\n  box-shadow: ",
    ";\n  transition: all 0.3s ease-out;\n"])), function (_a) {
    var showOverflow = _a.showOverflow;
    return (showOverflow ? 'visible' : 'hidden');
}, function (_a) {
    var theme = _a.theme, isActive = _a.isActive;
    return isActive ? theme.component.cardwrapper.seperatorSize : '0px';
}, function (_a) {
    var theme = _a.theme, isActive = _a.isActive;
    return isActive
        ? "0px 0px 0px 20px " + theme.component.cardwrapper.activeColor
        : "0px 0px 0px 0px " + theme.component.cardwrapper.activeColor;
});
var CardHeader = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  padding: 0.5rem 1rem;\n"], ["\n  display: flex;\n  align-items: center;\n  padding: 0.5rem 1rem;\n"])));
var CardHeadIconWrapper = styled.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  display: block;\n  width: 3.25rem;\n  height: 3.25rem;\n  border-radius: 100%;\n  margin-right: 1rem;\n  background-color: ", ";\n  position: relative;\n\n  & > *:first-child {\n    position: absolute;\n    width: 2rem;\n    height: 2rem;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    color: ", ";\n    fill: ", ";\n  }\n"], ["\n  display: block;\n  width: 3.25rem;\n  height: 3.25rem;\n  border-radius: 100%;\n  margin-right: 1rem;\n  background-color: ",
    ";\n  position: relative;\n\n  & > *:first-child {\n    position: absolute;\n    width: 2rem;\n    height: 2rem;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    color: ",
    ";\n    fill: ",
    ";\n  }\n"])), function (_a) {
    var variant = _a.variant, theme = _a.theme;
    return variant === 'light' ? theme.greyLight.color.normal : theme.greyDark.color.normal;
}, function (_a) {
    var variant = _a.variant, theme = _a.theme;
    return variant === 'light' ? theme.greyLight.color.text : theme.greyDark.color.text;
}, function (_a) {
    var variant = _a.variant, theme = _a.theme;
    return variant === 'light' ? theme.greyLight.color.text : theme.greyDark.color.text;
});
var CardHeadlineWrapper = styled.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  flex: 1 1 80%;\n"], ["\n  flex: 1 1 80%;\n"])));
export var CardSeperator = styled.div(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  display: block;\n  border-top: 1px solid;\n  border-color: ", ";\n"], ["\n  display: block;\n  border-top: 1px solid;\n  border-color: ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return theme.component.cardwrapper.seperatorColor;
});
export var HeadlineElement = styled.div(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n  ", ";\n  color: ", ";\n  font-size: ", ";\n  font-weight: ", ";\n  line-height: ", ";\n  letter-spacing: ", ";\n"], ["\n  ", ";\n  color: ", ";\n  font-size: ", ";\n  font-weight: ", ";\n  line-height: ", ";\n  letter-spacing: ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return theme.component.cardwrapper.headlineFont;
}, function (_a) {
    var theme = _a.theme;
    return theme.component.cardwrapper.headlineColor;
}, function (_a) {
    var theme = _a.theme;
    return theme.component.cardwrapper.headlineSize;
}, function (_a) {
    var theme = _a.theme;
    return theme.component.cardwrapper.headlineFontWeight;
}, function (_a) {
    var theme = _a.theme;
    return theme.component.cardwrapper.headlineLineHeight;
}, function (_a) {
    var theme = _a.theme;
    return theme.component.cardwrapper.headlineletterSpacing;
});
export var SubHeadlineElement = styled.div(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n  ", ";\n  color: ", ";\n  font-size: ", ";\n  font-weight: ", ";\n  line-height: ", ";\n  letter-spacing: ", ";\n"], ["\n  ", ";\n  color: ", ";\n  font-size: ",
    ";\n  font-weight: ", ";\n  line-height: ",
    ";\n  letter-spacing: ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return theme.component.cardwrapper.headlineFont;
}, function (_a) {
    var theme = _a.theme;
    return theme.component.cardwrapper.subheadlineColor;
}, function (_a) {
    var theme = _a.theme, condensed = _a.condensed;
    return condensed
        ? theme.component.cardwrapper.subheadlineCondensedSize
        : theme.component.cardwrapper.subheadlineSize;
}, function (_a) {
    var theme = _a.theme;
    return theme.component.cardwrapper.subheadlineFontWeight;
}, function (_a) {
    var theme = _a.theme, condensed = _a.condensed;
    return condensed
        ? theme.component.cardwrapper.subheadlineCondensedLineHeight
        : theme.component.cardwrapper.subheadlineLineHeight;
}, function (_a) {
    var theme = _a.theme;
    return theme.component.cardwrapper.subheadlineLetterSpacing;
});
var CardActionWrapper = styled.div(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  padding: 0.5rem 1rem;\n\n  ", "\n"], ["\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  padding: 0.5rem 1rem;\n\n  ",
    "\n"])), function (_a) {
    var isClickable = _a.isClickable;
    return isClickable &&
        "\n    cursor: pointer;\n  ";
});
var CardActionIcon = styled.div(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n  height: 1.5rem;\n  width: 1.5rem;\n  margin-right: 1rem;\n\n  & > * {\n    height: 1.5rem;\n    width: 1.5rem;\n  }\n"], ["\n  height: 1.5rem;\n  width: 1.5rem;\n  margin-right: 1rem;\n\n  & > * {\n    height: 1.5rem;\n    width: 1.5rem;\n  }\n"])));
var CardActionText = styled.div(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n  color: ", ";\n  font-size: 0.813rem;\n  font-weight: 500;\n"], ["\n  color: ", ";\n  font-size: 0.813rem;\n  font-weight: 500;\n"])), function (_a) {
    var theme = _a.theme;
    return theme.base.color.text;
});
export var CardAction = function (_a) {
    var icon = _a.icon, text = _a.text, onClick = _a.onClick;
    return (React.createElement(CardActionWrapper, { isClickable: onClick !== undefined, onClick: onClick },
        React.createElement(CardActionIcon, null, icon),
        React.createElement(CardActionText, null, text)));
};
export var DefaultCard = function (_a) {
    var _b = _a.elevationLevel, elevationLevel = _b === void 0 ? ElevationLevel['1dp'] : _b, headline = _a.headline, subHeadline = _a.subHeadline, action = _a.action, isActive = _a.isActive, _c = _a.cardTestId, cardTestId = _c === void 0 ? 'card' : _c, children = _a.children, className = _a.className, showHeaderSeparator = _a.showHeaderSeparator, headerIcon = _a.headerIcon, _d = _a.headerVariant, headerVariant = _d === void 0 ? 'light' : _d, _e = _a.condensedSubHeadline, condensedSubHeadline = _e === void 0 ? false : _e, _f = _a.showOverflow, showOverflow = _f === void 0 ? false : _f;
    // Move default values of booleans to here because storybook-readme crashes otherwise for booleans
    var renderedIsActive = isActive !== undefined ? isActive : false;
    var renderedShowHeaderSeperator = showHeaderSeparator !== undefined ? showHeaderSeparator : true;
    return (React.createElement(ComponentThemeProvider, { theme: cardTheme },
        React.createElement(CardWrapper, { elevationLevel: elevationLevel, showOverflow: showOverflow, "data-testid": cardTestId, className: className },
            React.createElement(CardActiveWrapper, { isActive: renderedIsActive, showOverflow: showOverflow, "data-testid": renderedIsActive ? 'card-active' : 'card-inactive' },
                (headerIcon || headline || subHeadline || action) && (React.createElement(React.Fragment, null,
                    React.createElement(CardHeader, null,
                        headerIcon && (React.createElement(CardHeadIconWrapper, { variant: headerVariant }, headerIcon)),
                        React.createElement(CardHeadlineWrapper, null,
                            headline && React.createElement(HeadlineElement, null, headline),
                            subHeadline && (React.createElement(SubHeadlineElement, { condensed: condensedSubHeadline }, subHeadline))),
                        action),
                    renderedShowHeaderSeperator && React.createElement(CardSeperator, null))),
                children))));
};
export default DefaultCard;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11;
//# sourceMappingURL=index.js.map